import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import serviceProvider from '../../services/axios'
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
export const ProfileTabPanel = (props) => {
	
	const [isCirDdl, setIsCirDdl] = useState(false);
	const [perBtnState, setPerBtnState] = useState("btn__disabled");
	const [addBtnState, setAddBtnState] = useState("btn__disabled");
	const [passBtnState, setPassBtnState] = useState("btn__disabled");
	const [pFormError, setPFormError] = useState(0);
	const [uFormError, setUFormError] = useState(0);
	const [passFormError, setPassFormError] = useState(0);
	const [passButtonText, setPassButtonText] = useState("Update");
	const [profileDdl, setProfileDdl] = useState(false);
	const [selectedFile, setSelectedFile] = useState(null);
	const [selectedImage, setSelectedImage] = useState(null);
	const [isProfilePhotoPopup, setIsProfilePhotoPopup] = useState(false);
	const [isProfileImgUpdloaded, setIsProfileImgUpdloaded] = useState(false);
	
	const profileDataItems = props.profileData;
	
	const profileDataItem = props.profileData[0];
	const uid = profileDataItem.id;
	const [countryList, setCountryList] = useState(props.defaultCountryList);
	const [profileCountry, setProfileCountry] = useState(profileDataItem.country_id);
	const [isProfileImgUpdload, setIsProfileImgUpdload] = useState(profileDataItem.profile_pic);
	
	const HandleOnSearch = (e) => {
		const val = e.target.value.toLowerCase();
		const filterData = countryList.filter((item) => {
			let rgx = new RegExp(val);
			return rgx.test(item.name.toLowerCase());
		});
		if (val) {
			setCountryList(filterData);
		} else {
			setCountryList(props.defaultCountryList);
		}
	};
	
	// function to handle country dropdown list
	const handleFNameChange = (event) => {
		var element = document.getElementById(event.target.name);
		if (event.target.value) {
			element.classList.remove("show-error");
			if (pFormError) {
				setPFormError(pFormError + 1);
			}
		} else {
			element.classList.add("show-error");
			setPFormError(pFormError + 1);
		}
	};
	const handleLNameChange = (event) => {
		var element = document.getElementById(event.target.name);
		if (event.target.value) {
			element.classList.remove("show-error");
			if (pFormError) {
				setPFormError(pFormError - 1);
			}
		} else {
			element.classList.add("show-error");
			setPFormError(pFormError + 1);
		}
	};
	const handlePerChange = () => {
		setPerBtnState("");
	};
	const handleAddChange = () => {
		setAddBtnState("");
	};
	const handlePhoneChange = (phone) => {
		var element = document.getElementById("phoneNo");
		console.log(phone);
		if (phone) {
			element.classList.remove("show-error");
			if (pFormError) {
				setPFormError(pFormError - 1);
			}
		} else {
			element.classList.add("show-error");
			setPFormError(pFormError + 1);
		}
		setPerBtnState("");
	};
	const handleCityChange = (event) => {
		var element = document.getElementById(event.target.name);
		if (event.target.value) {
			element.classList.remove("show-error");
			if (uFormError) {
				setUFormError(uFormError - 1);
			}
		} else {
			element.classList.add("show-error");
			setUFormError(uFormError + 1);
		}
		setAddBtnState("");
	};
	const handleZipChange = (event) => {
		var element = document.getElementById(event.target.name);
		if (event.target.value) {
			element.classList.remove("show-error");
			if (uFormError) {
				setUFormError(uFormError - 1);
			}
		} else {
			element.classList.add("show-error");
			setUFormError(uFormError + 1);
		}
		setAddBtnState("");
	};
	
	const handleOldPassChange = (event) => {
		var element = document.getElementById("oldPassSec");
		element.classList.remove("show-error");
		setPassBtnState("");
	};
	const handleNewPassChange = (event) => {
		var element = document.getElementById("newPassSec");
		var newReg = /^(?=.*[@$!%*#?&])(?=.*[0-9])[A-Za-z\d@$!%*#?&]{8,}$/;
		if (event.target.value.match(newReg)) {
			element.classList.remove("show-error");
			if (passFormError) {
				setPassFormError(passFormError - 1);
			}
		} else {
			document.getElementById("newPassErr").innerHTML = "Must Contain 8 Characters, One Number and one special case Character.";
			element.classList.add("show-error");
			setPassFormError(passFormError + 1);
		}
		setPassBtnState("");
	};
	const HandleCountryDdl = () => {
		setProfileDdl(!profileDdl);
		
	};
	// handle value of profilecountry
	const HandleCountryDdlValueOnClick = (val) => {
		document.getElementById("countryval").value = val;
		setProfileCountry(val);
		setAddBtnState("");
	};
	const HandleCirDdl = (action) => {
		if (action == "close") {
			setIsCirDdl(false);
		} else {
			let tmpVal = !isCirDdl;
			setIsCirDdl(tmpVal);
		}
	};
	const HandleProfilePopup = () => {
		setIsProfileImgUpdloaded(false);
		setSelectedImage(null);
		setIsProfilePhotoPopup(!isProfilePhotoPopup);
	};
	const HandleProfileImg = (e) => {
		const val = e.target.value;
		setIsProfileImgUpdloaded(val);
		setSelectedFile(e.target.files[0]);
		const objectUrl = URL.createObjectURL(e.target.files[0]);
		setSelectedImage(objectUrl);
	};
	const updateProfilePic = () => {
		const formData = new FormData();
		formData.append("uid", profileDataItem.id);
		formData.append("profilePic", selectedFile, selectedFile.name);
		
		serviceProvider.post("/profile?type=updateProfilePic", formData,true).then((response) => {
			// console.log(response.data);
			setIsProfileImgUpdload(true);
			setIsProfilePhotoPopup(!isProfilePhotoPopup);
			setIsProfileImgUpdload(response.data);
			props.onSubmitForm(response.data);
		});
	};
	const removeProfilePic = () => {
		const formData = new FormData();
		formData.append("uid", profileDataItem.id);
		serviceProvider.post("/profile?type=removeProfilePic", formData,true).then((response) => {
			// console.log(response.data);
			HandleCirDdl("close");
			setIsProfileImgUpdload(null);
			setIsProfileImgUpdloaded(false);
			setSelectedFile(null);
			setSelectedImage(null);
			props.onSubmitForm(response.data);
		});
	};
	const updatePersonalData = () => {
		let formData = new FormData(document.getElementById("personalDataForm"));
		console.log(pFormError);
		if (pFormError == 0) {
			serviceProvider.post("/profile?type=updatePersonalData", formData,true).then((response) => {
				console.log(response.data);
				if (response.data.status == 200) {
					localStorage.setItem("userData", JSON.stringify(response.data.data));
				}
				props.onSubmitForm(response.data.rand);
				setPerBtnState("btn__disabled");
			});
		}
	};
	const updateAddress = () => {
		
		let formData = new FormData(document.getElementById("addressForm"));
		console.log(uFormError);
		if (uFormError == 0) {
			serviceProvider.post("/profile?type=updateAddress", formData,true).then((response) => {
				// console.log(response.data);
				props.onSubmitForm(response.data);
				setAddBtnState("btn__disabled");
			});
		}
	};
	const updatePassword = () => {
		setPassButtonText("Updating...");
		let formData = new FormData(document.getElementById("passwordForm"));
		serviceProvider.post("/profile?type=updatePassword", formData,true).then((response) => {
			
			if (response.data == 0) {
				var element = document.getElementById("oldPassSec");
				element.classList.add("show-error");
				setPassButtonText("Update");
				setAddBtnState("btn__disabled");
				
				var element1 = document.getElementById("newPassSec");
		       element1.classList.remove("show-error");
		
				
				
			}else if(response.data == 2) {// not empty	
			    var element = document.getElementById("newPassSec");
				document.getElementById("newPassErr").innerHTML = "Must Contain 8 Characters, One Number and one special case Character.";
				element.classList.add("show-error");
				setPassButtonText("Update");
				setAddBtnState("btn__disabled");
			}else if(response.data == 3) {// not equal to same	
			    var element = document.getElementById("newPassSec");
				document.getElementById("newPassErr").innerHTML = "The new password can't be the same as the old password.";
			    element.classList.add("show-error");
				setPassButtonText("Update");
				setAddBtnState("btn__disabled");
			} else {
				document.getElementById("passwordForm").reset();
				setPassButtonText("Updated Successfully");
				setTimeout(() => {
					setPassButtonText("Update");
				}, 3000);
			}
		});
	};

	window.onclick = (e) => {
		if (!e.target.closest(".profile__img__div")) {
			HandleCirDdl("close");
		}
	};
	return (
		<>
			<div className="profile__tab__1">
				<div className="left__sec">
					<div className="profile__imgcir__container">
						<div className={`profile__img__div ${isCirDdl && "active"}`}>
							<div className="cir__div">
								{!isProfileImgUpdload ? (
									<span>{profileDataItem.short_name}</span>
								) : selectedImage ? (
									<img className="profile__img 1" src={selectedImage} alt={isProfileImgUpdload} />
								) : (
									<img
										className="profile__img 2"
										src={`https://apishowcasen.smarterchains.com/assets/user-profile/${isProfileImgUpdload}`}
										alt={isProfileImgUpdload}
									/>
								)}
								<button className="cam__icon__btn" onClick={HandleCirDdl}>
									<img src={require("../../assets/img/profile/cam-icon.svg").default} alt="cam__btn" />
								</button>
							</div>
							<div className="cir__ddl">
								<ul>
									{!isProfileImgUpdload ? (
										<li>
											<button
												className="btn__link"
												onClick={() => {
													HandleCirDdl("close");
													HandleProfilePopup();
												}}
											>
												Add profile photo
											</button>
										</li>
									) : (
										<>
											<li>
												<button
													className="btn__link"
													onClick={() => {
														HandleCirDdl("close");
														HandleProfilePopup();
													}}
												>
													Change profile photo
												</button>
											</li>
											<li>
												<button className="btn__link" onClick={removeProfilePic}>
													Remove
												</button>
											</li>
										</>
									)}
								</ul>
							</div>
						</div>
					</div>
					{/* profile__imgcir__container end */}
					<ul className="profile__detail__ul">
						<li>
							<label className="label">First Name</label>
							<p className="label__text">{profileDataItem.name}</p>
						</li>
						<li>
							<label className="label">Last Name</label>
							<p className="label__text">{profileDataItem.last_name}</p>
						</li>
						<li>
							<label className="label">Email</label>
							<p className="label__text">{profileDataItem.email}</p>
						</li>
					</ul>
				</div>
				{/* left__sec end */}
				<div className="right__sec">
					<div className="form-card">
						<form id="personalDataForm">
							<h2 className="form-title">Personal Information</h2>
							<input type="hidden" name="uid" defaultValue={profileDataItem.id} />
							<div id="firstName" className="profile__form__controller">
								<label className="label">
									<span className="label__text">First Name</span>
									<input
										type="text"
										defaultValue={profileDataItem.name}
										className="form__field"
										name="firstName"
										// readOnly
										placeholder="First Name"
										onChange={handlePerChange}
									/>
								</label>
								<p className="error">Please enter a valid First Name</p>
							</div>
							<div id="lastName" className="profile__form__controller">
								<label className="label">
									<span className="label__text">Last Name</span>
									<input
										type="text"
										defaultValue={profileDataItem.last_name}
										name="lastName"
										// readOnly
										className="form__field"
										placeholder="Last Name"
										onChange={handlePerChange}
									/>
								</label>
								<p className="error">Please enter a valid Last Name</p>
							</div>
							<div id="email" className="profile__form__controller profile__form__disabled">
								<label className="label">
									<span className="label__text">Email</span>
									<input
										type="text"
										defaultValue={profileDataItem.email}
										name="email"
										className="form__field"
										readOnly
										placeholder="Email"
									/>
								</label>
								<p className="error">Please enter a valid Email</p>
							</div>
							{/*  show-error */}
							
							<div className="profile__form__controller">
								<label className="label">
									<span className="label__text">Company</span>
									<input
										type="text"
										defaultValue={profileDataItem.company_name}
										name="companyName"
										className="form__field"
										placeholder="Company Name"
										onChange={handlePerChange}
									/>
								</label>
								<p className="error">Enter valid Country code</p>
							</div>
							<div className="profile__form__controller">
								<label className="label">
									<span className="label__text">Job Title</span>
									<input
										type="text"
										defaultValue={profileDataItem.job_title}
										name="jobTitle"
										className="form__field"
										placeholder="Job Title"
										onChange={handlePerChange}
									/>
								</label>
								<p className="error">Enter valid Job Title</p>
							</div>
							<div id="phoneNo" className="profile__form__controller ">
								<PhoneInput
									specialLabel="Phone number"
									inputClass="profile__phone__input"
									country={"us"}
									value={profileDataItem.phone_number}
									inputProps={{ name: "phoneNo" }}
									onChange={(phone) => handlePhoneChange(phone)}
								/>
								<p className="error">Enter valid Phone Number</p>
							</div>
						</form>
						<button onClick={updatePersonalData} className={`btn__updated ${perBtnState}`}>
							Update
						</button>
					</div>
					{/* form-card end */}
					<div className="form-card">
						<h2 className="form-title">Billing Address</h2>
						<form id="addressForm">
							<input type="hidden" name="uid" defaultValue={profileDataItem.id} />
							<div className="profile__form__controller">
								<label className="label">
									<span className="label__text">Address Line </span>
									<input
										type="text"
										name="address"
										defaultValue={profileDataItem.address}
										className="form__field"
										placeholder="e.g. 12 Main St"
										onChange={handleAddChange}
									/>
								</label>
								<p className="error">Please enter a valid Email Address</p>
							</div>
							<div className="form__row">
								<div className="form__col">
									<div id="city" className="profile__form__controller">
										<label className="label">
											<span className="label__text">City</span>
											<input
												type="text"
												name="city"
												defaultValue={profileDataItem.city}
												className="form__field"
												placeholder="e.g. Geneva"
												onChange={handleCityChange}
											/>
										</label>
										<p className="error">Enter valid City</p>
									</div>
								</div>
								<div className="form__col">
									<div className="profile__form__controller">
										<label className="label">
											<span className="label__text">State, province or region</span>
											<input
												type="text"
												name="state"
												defaultValue={profileDataItem.state_id}
												className="form__field"
												placeholder="e.g. NY"
												onChange={handleAddChange}
											/>
										</label>
										<p className="error">Enter valid Country code</p>
									</div>
								</div>
							</div>
							<div className="form__row">
								<div className="form__col">
									<div id="zipCode" className="profile__form__controller">
										<label className="label">
											<span className="label__text">ZIP code</span>
											<input
												type="text"
												name="zipCode"
												defaultValue={profileDataItem.zip_code}
												className="form__field"
												placeholder="e.g. 10024"
												onChange={handleZipChange}
											/>
										</label>
										<p className="error">Enter valid Zip code</p>
									</div>
								</div>
								<div className="form__col">
									<div className="profile__form__controller">
										<div className={profileDdl ? "label active" : "label"}>
											<span className="label__text">Country</span>
											<input type="hidden" id="countryval" name="country" defaultValue={profileCountry} />
											<button
												className={profileCountry ? "button selected" : "button"}
												onClick={HandleCountryDdl}
												type="button"
											>
												{profileCountry ? profileCountry : "Pick a country"}
												<span className="btn__ddl__arrow">
													<img src={require("../../assets/img/common-img/ddl-blue.svg").default} alt="true" />
												</span>
											</button>
											<div className="ddl__list__wrapper">
												<div className="ddl__list__card">
													<header>
														<label>
															<img src={require("../../assets/img/common-img/search-icon.svg").default} alt="true" />
															<input
																onChange={HandleOnSearch}
																type="text"
																placeholder="Search"
																autoComplete="off"
															/>
														</label>
													</header>
													<ul>
														{countryList.map((item, index) => {
															return (
																<li
																	key={index}
																	onClick={() => {
																		HandleCountryDdl();
																		HandleCountryDdlValueOnClick(item.name);
																	}}
																>
																	{item.name}
																</li>
															);
														})}
													</ul>
												</div>
											</div>
										</div>
										<p className="error">Enter valid Country code</p>
									</div>
								</div>
							</div>
						</form>
						<button onClick={updateAddress} className={`btn__updated ${addBtnState}`}>
							Update
						</button>
					</div>
					{/* form-card end */}
					<div className="form-card">
						<h2 className="form-title">Change your password</h2>
						<form id="passwordForm">
							<input type="hidden" name="uid" defaultValue={profileDataItem.id} />
							<div className="profile__form__controller" id="oldPassSec">
								<PasswordField
									id="password"
									name="old_password"
									label="Current Password"
									placeholder="Enter current password"
									onChangeHandler={handleOldPassChange}
								/>
								<p id="oldPassErr" className="error">
									Wrong Password
								</p>
							</div>
							<div className="profile__form__controller" id="newPassSec">
								<PasswordField
									id="newPassword"
									name="newpassword"
									label="New Password "
									placeholder="Enter new password"
									onChangeHandler={handleNewPassChange}
								/>
								<p id="newPassErr" className="error">
								Must Contain 8 Characters, One Number and one special case Character. 
								</p>
							</div>
						</form>
						<button onClick={updatePassword} className={`btn__updated ${passBtnState}`}>
							{passButtonText}
						</button>
					</div>
					{/* form-card end */}
				</div>
				{/* right__sec end */}
			</div>

			{/* profile photo-popup*/}
			<Modal
				open={isProfilePhotoPopup}
				onClose={HandleProfilePopup}
				aria-labelledby="simple-modal-title"
				aria-describedby="simple-modal-description"
				className="profile__pic__popup"
			>
				<div className="pic__popup__content">
					<div className="card">
						<header className="card-header">
							<span>Change profile photo</span>
							<button className="close_btn" onClick={HandleProfilePopup}>
								<img src={require("../../assets/img/common-img/close-icon-blue.svg").default} alt="close" />
							</button>
						</header>
						<div className="card-body">
							{!isProfileImgUpdloaded ? (
								<div className="without__upload">
									<label className="uplaod__img__cir">
										<div className="cloud__div">
											<img src={require("../../assets/img/common-img/cloud_upload.svg").default} alt="upload" />
											<p>Drag and drop your images here</p>
										</div>
										<input
											type="file"
											vlaue={isProfileImgUpdload}
											onChange={(e) => HandleProfileImg(e)}
											className="input-file"
											id="uploadProfileImg"
										/>
									</label>
									<p>or</p>
									<label className="uploadpic_btn" htmlFor="uploadProfileImg">
										Upload a photo
									</label>
								</div>
							) : (
								<div className="with__upload">
									<div className="with__upload__row">
										<div className="image__div">{selectedImage && <img src={selectedImage} alt="true" />}</div>
										<p>{selectedFile ? selectedFile.name : ""}</p>
									</div>
								</div>
							)}
						</div>
						<div className="card-footer">
							<button className="upload" onClick={updateProfilePic} disabled={isProfileImgUpdloaded ? false : true}>
								Upload
							</button>
							<button onClick={HandleProfilePopup} className="cancel">
								Cancel
							</button>
						</div>
					</div>
				</div>
			</Modal>
			{/* profile photo-popup end*/}
		</>
	);
};

const PasswordField = (props) => {
	const [isPass, setIsPass] = useState(true);
	return (
		<label className="label password">
			<span className="label__text">{props.label} </span>
			<input
				type={isPass ? "password" : "text"}
				id={props.id}
				name={props.name}
				className="form__field"
				placeholder={props.placeholder}
				onChange={props.onChangeHandler}
			/>
			<button
				className="btn__type__handle"
				type="button"
				onClick={() => {
					setIsPass(!isPass);
				}}
			>
				{isPass ? (
					<img src={require("../../assets/img/common-img/hidden-pass.svg").default} alt="hidden" />
				) : (
					<img src={require("../../assets/img/common-img/show-pass.svg").default} alt="show" />
				)}
			</button>
		</label>
	);
};
